// extracted by mini-css-extract-plugin
export default {"wrapper":"PostList_wrapper__+-SSA","posts":"PostList_posts__JEdF-","spaces":"PostList_spaces__gfiqu","noResults":"PostList_noResults__6qS2U","dragOver":"PostList_dragOver__kYPGD"};